<template>
  <div class="transfer-wrapper">
    <div class="d-flex justify-content-between align-items-center">
      <b-button-group size="sm" style="width: 204px" class="mb-4 custom-tabs">
        <b-button
          v-for="tab in tabs"
          :variant="activeTab === tab.value ? 'primary' : ''"
          @click="activeTab = tab.value"
          style="width: 100%; height: 30px"
          :key="tab.value"
          class="mr-1"
        >
          <div v-if="tab.show">
            {{ tab.text }}
          </div>
        </b-button>
      </b-button-group>

      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center mr-4" style="gap: 50px" v-if="showTransfergruppenInfos">
          <span class="font-weight-500" style="font-size: 13px" v-if="shwoOnlyAtTransferszenarioT4">
            Gebuchte Transfers:
            <strong>{{ AnzahlTnMitFlag ?? 0 }} / {{ this.pax.ist ?? '-' }}</strong>
          </span>
          <span class="font-weight-500" style="font-size: 13px" v-if="showMaxWartezeit">
            Max. Wartezeit:
            <strong>{{ MaxWartezeit ?? '-' }}</strong>
            Min
          </span>
          <span class="font-weight-500" style="font-size: 13px" v-if="showMaxAnzahlTransfergruppen">
            Max. Anzahl an Transfergruppen:
            <strong>{{ MaxTransfergruppen ?? 0 }}</strong>
          </span>
        </div>

        <b-button @click="toggleAllTransfers" class="icon-button">
          <Maximize2 v-if="!areAllTransfersExpanded" :size="20" />
          <Minimize2 v-else :size="20" />
        </b-button>
      </div>
    </div>

    <div v-if="activeTab === 'ankunft'">
      <div>
        <!-- Skeleton Loader während des Ladens -->
        <template v-if="loading">
          <b-skeleton height="30px" width="100%"></b-skeleton>
        </template>

        <template
          v-else-if="
            this.metadata.isKeineTransferplanungNotwendigHin ||
            this.metadata.transferszenarioHin === 'TX_ohne'
          "
        >
          <div class="text-center p-3">Keine Transferplanung notwendig.</div>
        </template>
        <template
          v-else-if="
            this.metadata.hinflugMaxAnzahlTransfergruppen == null &&
            this.metadata.transferszenarioHin !== 'T4_unbegr_exkl' &&
            this.metadata.transferszenarioHin !== 'TX_ohne' &&
            !this.metadata.isKeineTransferplanungNotwendigHin
          "
        >
          <div class="text-center p-3 text-danger">
            Es konnte keine automatische Transferplanung vorgenommen werden, da die max. Anzahl
            Transfergruppen in den Reisestammdaten nicht gepflegt ist.
          </div>
        </template>
        <template v-else>
          <!-- Transfergruppen -->
          <div v-if="areAnkuenfteExistent">
            <div v-for="(transfer, index) in ankunftTransfers" :key="transfer.id">
              <div
                class="transfer-header border cursor-pointer"
                :class="[
                  index % 2 === 0 ? 'bg-gray' : 'bg-white',
                  { 'is-expanded': isExpanded(transfer.id) },
                ]"
                @click="toggleExpanded(transfer.id)"
                style="border-color: #e5e7eb"
              >
                <div class="d-flex" style="font-size: 14px">
                  <div class="d-flex align-items-center justify-content-center" style="width: 20%">
                    <span v-b-tooltip.hover :title="getVerknuepfteKuerzel(transfer)" style="min-width: 20px">
                      <CalendarSync
                        v-if="isMindestensEinVerknuepfterGruppenTransferVorgang(transfer)"
                        :size="18"
                        class="text-danger"
                      />
                    </span>
                    <span class="font-weight-bold ml-2">{{ transfer.title }}</span>
                  </div>
                  <div class="d-flex justify-content-center" style="width: 20%">
                    <span class="">Gruppe {{ index + 1 }} ({{ transfer.participants.length }})</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-center" style="width: 20%">
                    <i class="fas fa-plane" v-b-tooltip.hover title="Flughafen"></i>
                    <span class="ml-2">{{ transfer.flughafen }}</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-center" style="width: 20%">
                    <i class="fas fa-bus" v-b-tooltip.hover.html title="Abfahrtszeit<br>Transfer"></i>
                    <strong class="ml-2" style="width: 100px">{{ transfer.ankunftBus }}</strong>
                  </div>
                  <div class="d-flex justify-content-center" style="width: 20%">
                    <span>berechnet am {{ transfer.calculatedDate }}</span>
                  </div>
                </div>
              </div>

              <b-collapse :visible="isExpanded(transfer.id)">
                <div class="bg-white px-4 pt-4 pb-4">
                  <div class="d-flex align-items-center ml-1 mb-4">
                    <i class="fas fa-users"></i>
                    <span class="font-weight-bold ml-2" style="font-size: 14px">Teilnehmende</span>
                  </div>

                  <b-table
                    :items="transfer.participants"
                    :fields="transferFieldsHin"
                    :tbody-tr-class="getRowClass(transfer.participants)"
                    small
                    class="mb-0"
                    head-variant="light"
                    style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: var(--radius-md)"
                  >
                    <template #cell(BNR)="{ item }">
                      <span class="d-flex align-items-center">
                        <span style="min-width: 60px">{{ item.bnr }}</span>
                        <span
                          v-if="isVerknuepfterGruppenTransferTermin(item)"
                          v-b-tooltip.hover
                          :title="item.reiseterminKuerzel"
                          class="ml-1 d-inline-flex cursor-pointer"
                          @click.stop="navigateToReisetermin(item.reiseterminKuerzel)"
                        >
                          <CalendarSync :size="16" class="text-danger" />
                        </span>
                      </span>
                    </template>

                    <template #cell(teilnehmername)="{ item }">
                      {{ formatName(item.teilnehmername) }}
                    </template>

                    <template #cell(ankunftszeit)="{ item }">
                      {{ item.ankunftszeit }}
                    </template>

                    <template #cell(flugnummer)="{ item }">
                      {{ item.flugnummer }}
                    </template>

                    <template #cell(zusWartezeitAmFH)="{ item }">
                      {{ item.zusWartezeitAmFH }}
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- Restgruppe für Ankunft -->
          <div v-if="ankunftRestgruppe" :class="{ 'mt-8': areAnkuenfteExistent }">
            <div class="p-0">
              <div
                class="transfer-header d-flex align-items-center justify-content-between p-4"
                :class="{ 'is-expanded': isRestgruppeHinExpanded }"
                @click="isRestgruppeHinExpanded = !isRestgruppeHinExpanded"
                style="
                  cursor: pointer;
                  background-color: #fcfcfc;
                  border-radius: var(--radius-sm);
                  border: 1px solid var(--border);
                  height: 52px;
                "
              >
                <div class="d-flex align-items-center">
                  <i class="fas fa-exclamation-triangle mr-2 text-danger" style="font-size: 18px"></i>
                  <span style="font-weight: 500; font-size: 16px">
                    Teilnehmende ohne Transfergruppe ({{ ankunftRestgruppe.teilnehmer.length }})
                  </span>
                </div>
                <i
                  class="fas"
                  :class="isRestgruppeHinExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
                  style="font-size: 16px; color: black"
                ></i>
              </div>

              <b-collapse v-model="isRestgruppeHinExpanded">
                <div class="bg-white px-4 pt-4 pb-4">
                  <b-table
                    :items="ankunftRestgruppe.teilnehmer"
                    :fields="restgruppeFieldsHin"
                    :tbody-tr-class="getRowClass(ankunftRestgruppe.teilnehmer)"
                    small
                    class="mb-0"
                    head-variant="light"
                    style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: var(--radius-md)"
                  >
                    <template #cell(BNR)="{ item }">
                      <span class="d-flex align-items-center">
                        <span style="min-width: 60px">{{ item.bnr }}</span>
                        <span
                          v-if="isVerknuepfterGruppenTransferTermin(item)"
                          v-b-tooltip.hover
                          :title="item.reiseterminKuerzel"
                          class="ml-1 d-inline-flex cursor-pointer"
                          @click.stop="navigateToReisetermin(item.reiseterminKuerzel)"
                        >
                          <CalendarSync :size="16" class="text-danger" />
                        </span>
                      </span>
                    </template>

                    <template #cell(teilnehmername)="{ item }">
                      {{ formatName(item.teilnehmername) }}
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- Meldung wenn nichts vorhanden -->
          <div v-if="!areAnkuenfteExistent && !ankunftRestgruppe" class="text-center p-3">
            Es sind keine Transfergruppen vorhanden.
          </div>
        </template>
      </div>
    </div>

    <div v-if="activeTab === 'abflug'">
      <div>
        <!-- Skeleton Loader während des Ladens -->
        <template v-if="loading">
          <b-skeleton height="30px" width="100%"></b-skeleton>
        </template>

        <template
          v-else-if="
            (this.metadata.isKeineTransferplanungNotwendigRueck ||
              this.metadata.transferszenarioRueck === 'TX_ohne') &&
            abflugVerlaengerungsgruppe?.teilnehmer.length == 0
          "
        >
          <div class="text-center p-3">Keine Transferplanung notwendig.</div>
        </template>
        <template
          v-else-if="
            this.metadata.rueckflugMaxAnzahlTransfergruppen == null &&
            this.metadata.transferszenarioRueck !== 'T4_unbegr_exkl' &&
            this.metadata.transferszenarioRueck !== 'TX_ohne' &&
            !this.metadata.isKeineTransferplanungNotwendigRueck
          "
        >
          <div class="text-center p-3 text-danger">
            Es konnte keine automatische Transferplanung vorgenommen werden, da die max. Anzahl
            Transfergruppen in den Reisestammdaten nicht gepflegt ist.
          </div>
        </template>
        <template v-else>
          <!-- Transfergruppen -->
          <div v-if="areAbfluegeExistent">
            <div v-for="(transfer, index) in abflugTransfers" :key="transfer.id">
              <div
                class="transfer-header border cursor-pointer"
                :class="[
                  index % 2 === 0 ? 'bg-gray' : 'bg-white',
                  { 'is-expanded': isExpanded(transfer.id) },
                ]"
                @click="toggleExpanded(transfer.id)"
                style="border-color: #e5e7eb"
              >
                <div class="d-flex" style="font-size: 14px">
                  <div class="d-flex align-items-center justify-content-center" style="width: 20%">
                    <span v-b-tooltip.hover :title="getVerknuepfteKuerzel(transfer)" style="min-width: 20px">
                      <CalendarSync
                        v-if="isMindestensEinVerknuepfterGruppenTransferVorgang(transfer)"
                        :size="16"
                        class="text-danger"
                      />
                    </span>
                    <span class="font-weight-bold ml-2">{{ transfer.title }}</span>
                  </div>
                  <div class="d-flex justify-content-center" style="width: 20%">
                    <span class="">Gruppe {{ index + 1 }} ({{ transfer.participants.length }})</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-center" style="width: 20%">
                    <i class="fas fa-plane" v-b-tooltip.hover title="Flughafen"></i>
                    <span class="ml-2">{{ transfer.flughafen }}</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-center" style="width: 20%">
                    <i class="fas fa-plane-departure" v-b-tooltip.hover.html title="Früh. Abflugzeit"></i>
                    <strong class="ml-2" style="width: 100px">{{ transfer.abflugBus }}</strong>
                  </div>
                  <div class="d-flex justify-content-center" style="width: 20%">
                    <span>berechnet am {{ transfer.calculatedDate }}</span>
                  </div>
                </div>
              </div>

              <b-collapse :visible="isExpanded(transfer.id)" class="mb-2">
                <div class="bg-white px-4 pt-4 pb-4">
                  <div class="d-flex align-items-center ml-1 mb-4">
                    <i class="fas fa-users"></i>
                    <span class="font-weight-bold ml-2" style="font-size: 14px">Teilnehmende</span>
                  </div>

                  <b-table
                    :items="transfer.participants"
                    :fields="transferFieldsRueck"
                    :tbody-tr-class="getRowClass(transfer.participants)"
                    small
                    class="mb-0"
                    head-variant="light"
                    style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: var(--radius-md)"
                  >
                    <template #cell(BNR)="{ item }">
                      <span class="d-flex align-items-center">
                        <span style="min-width: 60px">{{ item.bnr }}</span>
                        <span
                          v-if="isVerknuepfterGruppenTransferTermin(item)"
                          v-b-tooltip.hover
                          :title="item.reiseterminKuerzel"
                          class="ml-1 d-inline-flex cursor-pointer"
                          @click.stop="navigateToReisetermin(item.reiseterminKuerzel)"
                        >
                          <CalendarSync :size="16" class="text-danger" />
                        </span>
                      </span>
                    </template>

                    <template #cell(teilnehmername)="{ item }">
                      {{ formatName(item.teilnehmername) }}
                    </template>

                    <template #cell(abflugszeit)="{ item }">
                      {{ item.abflugszeit }}
                    </template>

                    <template #cell(flugnummer)="{ item }">
                      {{ item.flugnummer }}
                    </template>

                    <template #cell(zusWartezeitAmFH)="{ item }">
                      {{ item.zusWartezeitAmFH }}
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- Verlängerungsgruppe für Abflug -->
          <div v-if="abflugVerlaengerungsgruppe" :class="{ 'mt-8': areAbfluegeExistent }">
            <div class="p-0">
              <div
                class="transfer-header d-flex align-items-center justify-content-between p-4"
                :class="{ 'is-expanded': isVerlaengerungsgruppeRueckExpanded }"
                @click="isVerlaengerungsgruppeRueckExpanded = !isVerlaengerungsgruppeRueckExpanded"
                style="
                  cursor: pointer;
                  background-color: #fcfcfc;
                  border-radius: var(--radius-sm);
                  border: 1px solid var(--border);
                  height: 52px;
                "
              >
                <div class="d-flex align-items-center">
                  <i class="fas fa-exclamation-triangle mr-2 text-danger" style="font-size: 18px"></i>
                  <span style="font-weight: 500; font-size: 16px">
                    Teilnehmende mit Verlängerung ({{ abflugVerlaengerungsgruppe.teilnehmer.length }})
                  </span>
                </div>
                <i
                  class="fas"
                  :class="isVerlaengerungsgruppeRueckExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
                  style="font-size: 16px; color: black"
                ></i>
              </div>

              <b-collapse v-model="isVerlaengerungsgruppeRueckExpanded">
                <div class="bg-white px-4 pt-4 pb-4">
                  <b-table
                    :items="abflugVerlaengerungsgruppe.teilnehmer"
                    :fields="verlaengerungsgruppeFieldsRueck"
                    :tbody-tr-class="getRowClass(abflugVerlaengerungsgruppe.teilnehmer)"
                    small
                    class="mb-0"
                    head-variant="light"
                    style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: var(--radius-md)"
                  >
                    <template #cell(BNR)="{ item }">
                      <span class="d-flex align-items-center">
                        <span style="min-width: 60px">{{ item.bnr }}</span>
                        <span
                          v-if="isVerknuepfterGruppenTransferTermin(item)"
                          v-b-tooltip.hover
                          :title="item.reiseterminKuerzel"
                          class="ml-1 d-inline-flex cursor-pointer"
                          @click.stop="navigateToReisetermin(item.reiseterminKuerzel)"
                        >
                          <CalendarSync :size="16" class="text-danger" />
                        </span>
                      </span>
                    </template>

                    <template #cell(teilnehmername)="{ item }">
                      {{ formatName(item.teilnehmername) }}
                    </template>

                    <template #cell(flugnummer)="{ item }">
                      {{ item.flugnummer }}
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- Restgruppe für Abflug -->
          <div v-if="abflugRestgruppe" :class="{ 'mt-8': areAbfluegeExistent || abflugVerlaengerungsgruppe }">
            <div class="p-0">
              <div
                class="transfer-header d-flex align-items-center justify-content-between p-4"
                :class="{ 'is-expanded': isRestgruppeRueckExpanded }"
                @click="isRestgruppeRueckExpanded = !isRestgruppeRueckExpanded"
                style="
                  cursor: pointer;
                  background-color: #fcfcfc;
                  border-radius: var(--radius-sm);
                  border: 1px solid var(--border);
                  height: 52px;
                "
              >
                <div class="d-flex align-items-center">
                  <i class="fas fa-exclamation-triangle mr-2 text-danger" style="font-size: 18px"></i>
                  <span style="font-weight: 500; font-size: 16px">
                    Teilnehmende ohne Transfergruppe ({{ abflugRestgruppe.teilnehmer.length }})
                  </span>
                </div>
                <i
                  class="fas"
                  :class="isRestgruppeRueckExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
                  style="font-size: 16px; color: black"
                ></i>
              </div>

              <b-collapse v-model="isRestgruppeRueckExpanded">
                <div class="bg-white px-4 pt-4 pb-4">
                  <b-table
                    :items="abflugRestgruppe.teilnehmer"
                    :fields="restgruppeFieldsRueck"
                    :tbody-tr-class="getRowClass(abflugRestgruppe.teilnehmer)"
                    small
                    class="mb-0"
                    head-variant="light"
                    style="border: 1px solid rgb(0, 0, 0, 0.1); border-radius: var(--radius-md)"
                  >
                    <template #cell(BNR)="{ item }">
                      <span class="d-flex align-items-center">
                        <span style="min-width: 60px">{{ item.bnr }}</span>
                        <span
                          v-if="isVerknuepfterGruppenTransferTermin(item)"
                          v-b-tooltip.hover
                          :title="item.reiseterminKuerzel"
                          class="ml-1 d-inline-flex cursor-pointer"
                          @click.stop="navigateToReisetermin(item.reiseterminKuerzel)"
                        >
                          <CalendarSync :size="16" class="text-danger" />
                        </span>
                      </span>
                    </template>

                    <template #cell(teilnehmername)="{ item }">
                      {{ formatName(item.teilnehmername) }}
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- Meldung wenn nichts vorhanden -->
          <div
            v-if="!areAbfluegeExistent && !abflugRestgruppe && !abflugVerlaengerungsgruppe"
            class="text-center p-3"
          >
            Es sind keine Transfergruppen vorhanden.
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { formatName, formatDate } from '@/core/common/helpers/utils';
import apiService from '@/core/common/services/api.service';
import { CalendarSync, Maximize2, Minimize2 } from 'lucide-vue';

export default {
  components: { CalendarSync, Maximize2, Minimize2 },
  props: {
    filteredVorgaenge: { type: Array, default: () => [] },
    reiseterminId: { type: [String, Number], required: true },
    reiseterminkuerzel: { type: String, required: true },
    metadata: { type: Object, required: true },
    pax: { type: Object, required: true },
    vorgaenge: { type: Array },
  },

  data() {
    return {
      activeTab: 'ankunft',
      expandedTransfers: {},
      transferData: {},
      loading: false,
      isRestgruppeHinExpanded: true,
      isRestgruppeRueckExpanded: true,
      isVerlaengerungsgruppeRueckExpanded: true,
    };
  },

  async mounted() {
    await this.loadTransferData(this.reiseterminId);
  },

  computed: {
    tabs() {
      return [
        { show: true, value: 'ankunft', text: 'Ankunft' },
        { show: true, value: 'abflug', text: 'Abflug' },
      ];
    },

    areAllTransfersExpanded() {
      if (this.activeTab === 'ankunft') {
        const allTransfersOpen =
          this.ankunftTransfers.length > 0 && this.ankunftTransfers.every(t => this.expandedTransfers[t.id]);
        const restgruppeOk = !this.ankunftRestgruppe || this.isRestgruppeHinExpanded;
        return allTransfersOpen && restgruppeOk;
      } else {
        const allTransfersOpen =
          this.abflugTransfers.length > 0 && this.abflugTransfers.every(t => this.expandedTransfers[t.id]);
        const restgruppeOk = !this.abflugRestgruppe || this.isRestgruppeRueckExpanded;
        const verlaengerungOk = !this.abflugVerlaengerungsgruppe || this.isVerlaengerungsgruppeRueckExpanded;
        return allTransfersOpen && restgruppeOk && verlaengerungOk;
      }
    },

    areAnkuenfteExistent() {
      return this.ankunftTransfers && this.ankunftTransfers.length > 0;
    },

    areAbfluegeExistent() {
      return this.abflugTransfers && this.abflugTransfers.length > 0;
    },

    ankunftTransfers() {
      const transfergruppen = this.transferData?.transfergruppen || [];

      return transfergruppen
        .filter(
          gruppe =>
            gruppe.typ === 'Hin' &&
            gruppe.bezeichner !== 'Restgruppe' &&
            gruppe.bezeichner !== 'Verlaengerungsgruppe'
        )
        .map(this.mapToTransferGroup)
        .sort((a, b) => {
          const dateA = new Date(a.title.split(': ')[1].split('.').reverse().join('-'));
          const dateB = new Date(b.title.split(': ')[1].split('.').reverse().join('-'));

          if (dateA.getTime() !== dateB.getTime()) {
            return dateA - dateB;
          }

          const timeA = a.ankunftBus.split(' - ')[0];
          const timeB = b.ankunftBus.split(' - ')[0];
          return timeA.localeCompare(timeB);
        });
    },

    abflugTransfers() {
      const transfergruppen = this.transferData?.transfergruppen || [];

      return transfergruppen
        .filter(
          gruppe =>
            gruppe.typ === 'Rueck' &&
            gruppe.bezeichner !== 'Restgruppe' &&
            gruppe.bezeichner !== 'Verlaengerungsgruppe'
        )
        .map(this.mapToTransferGroup)
        .sort((a, b) => {
          const dateA = new Date(a.title.split(': ')[1].split('.').reverse().join('-'));
          const dateB = new Date(b.title.split(': ')[1].split('.').reverse().join('-'));

          if (dateA.getTime() !== dateB.getTime()) {
            return dateA - dateB;
          }

          return a.abflugBus.localeCompare(b.abflugBus);
        });
    },

    abflugVerlaengerungsgruppe() {
      const transfergruppen = this.transferData?.transfergruppen || [];
      const verlaengerungsgruppe = transfergruppen.find(
        gruppe => gruppe.typ === 'Rueck' && gruppe.bezeichner === 'Verlaengerungsgruppe'
      );

      if (
        !verlaengerungsgruppe ||
        !verlaengerungsgruppe.teilnehmer ||
        verlaengerungsgruppe.teilnehmer.length === 0
      ) {
        return null;
      }

      return {
        teilnehmer: [...verlaengerungsgruppe.teilnehmer]
          .sort((a, b) => {
            if (!a.abflugszeit && !b.abflugszeit) return 0;
            if (!a.abflugszeit) return 1;
            if (!b.abflugszeit) return -1;
            return new Date(a.abflugszeit).getTime() - new Date(b.abflugszeit).getTime();
          })
          .map(teilnehmer => ({
            bnr: teilnehmer.bnr,
            teilnehmername: teilnehmer.name,
            reiseterminKuerzel: teilnehmer.reiseterminKuerzel,
            flugnummer: teilnehmer.flugnummer,
            abflugdatum: teilnehmer.abflugszeit
              ? new Date(teilnehmer.abflugszeit).toLocaleDateString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })
              : '-',
            abflugszeit: teilnehmer.abflugszeit
              ? new Date(teilnehmer.abflugszeit).toLocaleTimeString('de-DE', {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : '',
            zugeordnetAm: teilnehmer.zugeordnetAm || '-',
          })),
      };
    },

    ankunftRestgruppe() {
      const transfergruppen = this.transferData?.transfergruppen || [];
      const restgruppe = transfergruppen.find(
        gruppe => gruppe.typ === 'Hin' && gruppe.bezeichner === 'Restgruppe'
      );

      if (!restgruppe || !restgruppe.teilnehmer || restgruppe.teilnehmer.length === 0) {
        return null;
      }

      return {
        teilnehmer: restgruppe.teilnehmer.map(teilnehmer => ({
          bnr: teilnehmer.bnr,
          teilnehmername: teilnehmer.name,
          reiseterminKuerzel: teilnehmer.reiseterminKuerzel,
          zugeordnetAm: teilnehmer.zugeordnetAm || '-',
        })),
      };
    },

    abflugRestgruppe() {
      const transfergruppen = this.transferData?.transfergruppen || [];
      const restgruppe = transfergruppen.find(
        gruppe => gruppe.typ === 'Rueck' && gruppe.bezeichner === 'Restgruppe'
      );

      if (!restgruppe || !restgruppe.teilnehmer || restgruppe.teilnehmer.length === 0) {
        return null;
      }

      return {
        teilnehmer: restgruppe.teilnehmer.map(teilnehmer => ({
          bnr: teilnehmer.bnr,
          teilnehmername: teilnehmer.name,
          reiseterminKuerzel: teilnehmer.reiseterminKuerzel,
          zugeordnetAm: teilnehmer.zugeordnetAm || '-',
        })),
      };
    },

    transferFieldsHin() {
      return [
        {
          key: 'BNR',
          label: 'BNR',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'teilnehmername',
          label: 'Teilnehmername',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'flugnummer',
          label: 'Flugnummer',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'ankunftszeit',
          label: 'Ankunft',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'zusWartezeitAmFH',
          label: 'Zus. Wartezeit am FH',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'zugeordnetAm',
          label: 'Hinzugefügt am',
          formatter: this.formatDate,
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
      ];
    },

    transferFieldsRueck() {
      return [
        {
          key: 'BNR',
          label: 'BNR',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'teilnehmername',
          label: 'Teilnehmername',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'flugnummer',
          label: 'Flugnummer',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'abflugszeit',
          label: 'Abflug',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'zusWartezeitAmFH',
          label: 'Zus. Wartezeit am FH',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'zugeordnetAm',
          label: 'Hinzugefügt am',
          formatter: this.formatDate,
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
      ];
    },

    verlaengerungsgruppeFieldsRueck() {
      return [
        {
          key: 'BNR',
          label: 'BNR',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'teilnehmername',
          label: 'Teilnehmername',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },

        {
          key: 'flugnummer',
          label: 'Flugnummer',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },

        {
          key: 'abflugdatum',
          label: 'Abflugdatum',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },

        {
          key: 'abflugszeit',
          label: 'Abflugzeit',
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'zugeordnetAm',
          label: 'Hinzugefügt am',
          formatter: this.formatDate,
          thStyle: {
            width: '16.66%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
      ];
    },

    restgruppeFieldsHin() {
      return [
        {
          key: 'BNR',
          label: 'BNR',
          thStyle: {
            width: '20%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'teilnehmername',
          label: 'Teilnehmername',
          thStyle: {
            width: '60%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'zugeordnetAm',
          label: 'Hinzugefügt am',
          formatter: this.formatDate,
          thStyle: {
            width: '20%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
      ];
    },

    restgruppeFieldsRueck() {
      return [
        {
          key: 'BNR',
          label: 'BNR',
          thStyle: {
            width: '20%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'teilnehmername',
          label: 'Teilnehmername',
          thStyle: {
            width: '60%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
        {
          key: 'zugeordnetAm',
          label: 'Hinzugefügt am',
          formatter: this.formatDate,
          thStyle: {
            width: '20%',
            fontSize: '13px',
            fontWeight: '500',
          },
        },
      ];
    },

    AnzahlTnMitFlag() {
      const alleTeilnehmer = this.vorgaenge.flatMap(vorgang => vorgang.teilnehmers);

      if (this.activeTab === 'ankunft') {
        return alleTeilnehmer.filter(teilnehmer => teilnehmer.transferBookedHin === true).length;
      } else {
        return alleTeilnehmer.filter(teilnehmer => teilnehmer.transferBookedRueck === true).length;
      }
    },

    MaxWartezeit() {
      if (this.activeTab === 'ankunft') {
        return this.metadata.hinflugMaxWartezeit;
      } else {
        return this.metadata.rueckflugMaxWartezeit;
      }
    },

    MaxTransfergruppen() {
      if (this.activeTab === 'ankunft') {
        return this.metadata.hinflugMaxAnzahlTransfergruppen;
      } else {
        return this.metadata.rueckflugMaxAnzahlTransfergruppen;
      }
    },

    shwoOnlyAtTransferszenarioT4() {
      if (this.activeTab === 'ankunft') {
        return (
          !this.isKeineTransferplanungNotwendigHin && this.metadata.transferszenarioHin === 'T4_unbegr_exkl'
        );
      } else {
        return (
          !this.isKeineTransferplanungNotwendigRueck &&
          this.metadata.transferszenarioRueck === 'T4_unbegr_exkl'
        );
      }
    },

    showTransfergruppenInfos() {
      if (this.activeTab === 'ankunft') {
        return this.metadata.transferszenarioHin !== 'TX_ohne';
      } else {
        return this.metadata.transferszenarioRueck !== 'TX_ohne';
      }
    },

    isKeineTransferplanungNotwendigHin() {
      return this.metadata.isKeineTransferplanungNotwendigHin === true;
    },

    isKeineTransferplanungNotwendigRueck() {
      return this.metadata.isKeineTransferplanungNotwendigRueck === true;
    },

    showMaxWartezeit() {
      if (this.activeTab === 'ankunft') {
        return !this.isKeineTransferplanungNotwendigHin;
      } else {
        return !this.isKeineTransferplanungNotwendigRueck;
      }
    },

    showMaxAnzahlTransfergruppen() {
      if (this.activeTab === 'ankunft') {
        return (
          !this.isKeineTransferplanungNotwendigHin &&
          this.metadata.transferszenarioHin !== 'T4_unbegr_exkl' &&
          this.metadata.maxTransfergruppenBeachtenHin !== false
        );
      } else {
        return (
          !this.isKeineTransferplanungNotwendigRueck &&
          this.metadata.transferszenarioRueck !== 'T4_unbegr_exkl' &&
          this.metadata.maxTransfergruppenBeachtenRueck !== false
        );
      }
    },
  },

  methods: {
    formatName,
    formatDate,
    async loadTransferData(reiseterminId) {
      try {
        this.loading = true;
        const TransferdataResponse = await apiService.get(`/Reisetermin/${reiseterminId}/transfergruppen`);

        const transferData = TransferdataResponse?.data?.result || {};

        this.transferData = transferData;
      } catch (error) {
        console.error('Fehler beim Laden der Transferdaten:', error);
        this.transferData = {};
      } finally {
        this.loading = false;
      }
    },

    mapToTransferGroup(gruppe) {
      let anzeigeZeitBus, transferZeit, endTimeBusHin;

      if (gruppe.typ === 'Hin') {
        // Für Ankunft (Anzeige für den Bus): Späteste Ankunftszeit in der Gruppe + 45 Minuten
        const ankunftszeiten = (gruppe.teilnehmer || [])
          .filter(t => t.ankunftszeit)
          .map(t => new Date(t.ankunftszeit));

        if (ankunftszeiten.length > 0) {
          const spaetesteAnkunft = new Date(Math.max(...ankunftszeiten));
          transferZeit = new Date(spaetesteAnkunft.getTime() + 45 * 60 * 1000);
          anzeigeZeitBus = transferZeit.toLocaleTimeString('de-DE', {
            hour: '2-digit',
            minute: '2-digit',
          });
          endTimeBusHin = new Date(transferZeit.getTime() + 30 * 60 * 1000).toLocaleTimeString('de-DE', {
            hour: '2-digit',
            minute: '2-digit',
          });
        }
      } else {
        // Für Abflug
        const abflugTransferzeit = new Date(gruppe.zeit);
        transferZeit = abflugTransferzeit;
        anzeigeZeitBus = abflugTransferzeit.toLocaleTimeString('de-DE', {
          hour: '2-digit',
          minute: '2-digit',
        });
      }

      const datum = (transferZeit || new Date(gruppe.zeit)).toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

      const teilnehmer =
        gruppe.typ === 'Hin'
          ? this.sortTeilnehmerByAnkunftszeit(gruppe.teilnehmer || [])
          : gruppe.teilnehmer || [];

      return {
        id: gruppe.id,
        title: `${gruppe.typ === 'Hin' ? 'Ankunft' : 'Abflug'}: ${datum}`,
        flughafen: gruppe.flughafen,
        ankunftBus: `${anzeigeZeitBus} - ${endTimeBusHin}`,
        abflugBus: anzeigeZeitBus,
        calculatedDate: new Date(gruppe.createdDateUtc).toLocaleDateString('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
        participants: this.filterAndMapTeilnehmende(teilnehmer, gruppe.zeit),
      };
    },

    sortTeilnehmerByAnkunftszeit(teilnehmer) {
      return [...teilnehmer].sort((a, b) => {
        if (!a.ankunftszeit && !b.ankunftszeit) return 0;
        if (!a.ankunftszeit) return 1;
        if (!b.ankunftszeit) return -1;
        return new Date(a.ankunftszeit).getTime() - new Date(b.ankunftszeit).getTime();
      });
    },

    // um dem b-table ein flaches Objekt zu übergeben -> erstellt für jeden teilnehmer ein Objekt
    filterAndMapTeilnehmende(teilnehmer, gruppeZeit) {
      return teilnehmer.map(teilnehmerObj => {
        const transfergruppenZeit = new Date(gruppeZeit);
        let zusWartezeitAmFH = '';

        // Für Ankunft: Delta zwischen Ankunftszeit und gruppe.zeit
        if (teilnehmerObj.ankunftszeit) {
          const flugAnkunft = new Date(teilnehmerObj.ankunftszeit);
          const wartezeitMinuten = Math.floor(
            (transfergruppenZeit.getTime() - flugAnkunft.getTime()) / (1000 * 60)
          );
          zusWartezeitAmFH = wartezeitMinuten >= 0 ? `${wartezeitMinuten} Min` : '0 Min';
        }

        // Für Abflug: Delta zwischen Abflugszeit und gruppe.zeit
        if (teilnehmerObj.abflugszeit) {
          const flugAbflug = new Date(teilnehmerObj.abflugszeit);
          const wartezeitMinuten = Math.floor(
            (flugAbflug.getTime() - transfergruppenZeit.getTime()) / (1000 * 60)
          );
          zusWartezeitAmFH = wartezeitMinuten >= 0 ? `${wartezeitMinuten} Min` : '0 Min';
        }

        return {
          id: teilnehmerObj.bnr,
          bnr: teilnehmerObj.bnr,
          teilnehmername: teilnehmerObj.name,
          flugnummer: teilnehmerObj.flugnummer || '',
          reiseterminKuerzel: teilnehmerObj.reiseterminKuerzel,
          ankunftszeit: teilnehmerObj.ankunftszeit
            ? new Date(teilnehmerObj.ankunftszeit)
                .toLocaleDateString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
                .replace(',', '')
            : '',
          abflugszeit: teilnehmerObj.abflugszeit
            ? new Date(teilnehmerObj.abflugszeit)
                .toLocaleTimeString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
                .replace(',', '')
            : '',
          zusWartezeitAmFH,
          zugeordnetAm: teilnehmerObj.zugeordnetAm || '-',
        };
      });
    },

    async navigateToReisetermin(kuerzel) {
      try {
        const res = await apiService.get(`Reisetermin?$filter=reiseterminkuerzel eq '${kuerzel}'&$select=id`);
        const reisetermin = res.data?.result?.value?.[0];
        if (reisetermin) {
          const isReleasepruefung = this.$route.name === 'reisetermin-view-releasepruefung';
          const path = isReleasepruefung
            ? `/#/reisetermine/${reisetermin.id}/releasepruefung?releasepruefungstab=transfer&scrollToFlugdaten=true`
            : `/#/reisetermine/${reisetermin.id}/?vorgangdetailstab=transfer&scrollToFlugdaten=true`;
          window.open(path, '_blank');
        }
      } catch (error) {
        console.error('Fehler beim Navigieren zum Reisetermin:', error);
      }
    },

    getVerknuepfteKuerzel(transfer) {
      return [
        ...new Set(
          transfer.participants
            .filter(p => this.isVerknuepfterGruppenTransferTermin(p))
            .map(p => p.reiseterminKuerzel)
        ),
      ].join(', ');
    },

    isMindestensEinVerknuepfterGruppenTransferVorgang(transfer) {
      return (
        transfer.participants.length > 0 &&
        transfer.participants.some(p => this.isVerknuepfterGruppenTransferTermin(p))
      );
    },

    isVerknuepfterGruppenTransferTermin(item) {
      return item.reiseterminKuerzel && item.reiseterminKuerzel !== this.reiseterminkuerzel;
    },

    getRowClass(items) {
      const liste = items || [];
      const bnrReihenfolge = [...new Set(liste.map(teilnehmer => teilnehmer.bnr))];
      // Letzte Zeile jeder BNR-Gruppe merken, um dort die Trennlinie zu setzen
      const gruppenEnden = new Set(liste.filter((tn, i) => liste[i + 1]?.bnr !== tn.bnr));

      return item => {
        const farbe = bnrReihenfolge.indexOf(item.bnr) % 2 === 0 ? 'bnr-group-white' : 'bnr-group-gray';
        const verknuepft = this.isVerknuepfterGruppenTransferTermin(item)
          ? 'verknuepfterGruppenTransfer-row'
          : '';
        const gruppenEnde = gruppenEnden.has(item) ? 'bnr-group-end' : '';
        return [farbe, verknuepft, gruppenEnde];
      };
    },

    toggleAllTransfers() {
      const expand = !this.areAllTransfersExpanded;
      if (this.activeTab === 'ankunft') {
        this.ankunftTransfers.forEach(t => {
          this.$set(this.expandedTransfers, t.id, expand);
        });
        if (this.ankunftRestgruppe) {
          this.isRestgruppeHinExpanded = expand;
        }
      } else {
        this.abflugTransfers.forEach(t => {
          this.$set(this.expandedTransfers, t.id, expand);
        });
        if (this.abflugRestgruppe) {
          this.isRestgruppeRueckExpanded = expand;
        }
        if (this.abflugVerlaengerungsgruppe) {
          this.isVerlaengerungsgruppeRueckExpanded = expand;
        }
      }
    },

    toggleExpanded(transferId) {
      this.$set(this.expandedTransfers, transferId, !this.expandedTransfers[transferId]);
    },

    isExpanded(transferId) {
      return Boolean(this.expandedTransfers[transferId]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/sass/components/expandable-section-styles.scss';

.transfer-header {
  height: 52px;
  align-content: center;
}

.transfer-header.bg-gray {
  background-color: var(--surface-sunken);
}

.transfer-header.bg-white {
  background-color: var(--surface);
}

.transfer-header.is-expanded {
  background-color: #e5f0fb !important;
}

.transfer-header:hover {
  background-color: #e5f0fb !important;
}

.cursor-pointer {
  cursor: pointer;
}

.table {
  border-radius: 5px;
  overflow: hidden;
  border-collapse: separate;
  border-spacing: 0;
}

::v-deep .table td {
  border-top: none;
  height: 30px;
}

::v-deep .bnr-group-end td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.transfer-header:has(+ .collapse.show) {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

::v-deep .table td,
::v-deep .table th {
  align-content: center;
  padding-left: 5%;
}

::v-deep .table th {
  height: 30px;
}

::v-deep .verknuepfterGruppenTransfer-row td {
  color: #9899a3;
}

::v-deep .bnr-group-white td {
  background-color: var(--surface);
}

::v-deep .bnr-group-gray td {
  background-color: #fcfcfc;
}

.font-weight-500 {
  font-weight: 500;
}

.custom-tabs .btn {
  border-radius: 3px !important;
  width: 100px !important;
  height: 30px !important;
  font-size: 12px !important;
  line-height: 100% !important;
}

.custom-tabs .btn-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}
</style>
